/**
 * Created by S240895 on 25/05/2018.
 */
export class ReportCard {
    constructor(
        public id?: number,
        public blobId?: number,
        public blobFilename?: string
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/report-card/report-card.model.ts